export default __webpack_public_path__ + "static/media/kingdom-points-tutorial.e74d42d6.png";